<template>
  <VChip density="compact" :class="chip({ variant })">
    <VIcon v-if="icon" :icon="icon" start size="16px" color="currentColor" />
    {{ text }}
  </VChip>
</template>

<script setup lang="ts">
import { cva, type VariantProps } from 'class-variance-authority'

export type ChipProps = VariantProps<typeof chip>

const chip = cva(
  'chip px-2 py-0 rounded-[4px] !text-[14px] leading-[24px] font-semibold border border-[#0000001A]',
  {
    variants: {
      variant: {
        primary: ['bg-[#1F2937]', 'text-white'],
        secondary: ['bg-[#0000000D]', 'text-[#000000CC]'],
        success: ['bg-[#4CAF50]', 'text-white'],
        warning: ['bg-[#FF9900]', 'text-[#000000CC]'],
        error: ['bg-[#FDF0EF]', 'text-[#D75D58]', 'border-[#F29895]']
      }
    },
    defaultVariants: {
      variant: 'primary'
    }
  }
)

const {
  text = '',
  icon,
  variant = 'primary'
} = defineProps<{
  text?: string
  icon?: string
  variant?: ChipProps['variant']
}>()
</script>

<style scoped>
.chip {
  --v-activated-opacity: 0;
}
</style>
